import { useField } from "formik";

import {
  FeatureFlag,
  useFeatureFlag,
} from "@vega-api/extended/auth/useFeatureFlag";
import { useTouchFieldOnSubmit } from "@vega-core/helpers/formik.helper";
import { m } from "@vega-core/paraglide/messages";

import { useCountryCodes } from "../../../scenes/Subscription/hooks/useCountryCodes";
import { CountrySelector } from "../Controls/CountrySelector/CountrySelector";

type Props = {
  isRequired?: boolean;
  label?: string;
  name: string;
  tooltipContent?: string;
  fullWidth?: boolean;
  constrainInputWidth?: boolean;
};

export function CountryField({
  isRequired,
  label,
  name,
  tooltipContent,
  fullWidth,
  constrainInputWidth = false,
}: Props) {
  const [field, meta, helpers] = useField(name);
  useTouchFieldOnSubmit(name);
  const { featureFlag } = useFeatureFlag();
  const isAlpha2Enabled = featureFlag[FeatureFlag.ALPHA_2_CODE_SUPPORT];

  const { getCountryCodeByName } = useCountryCodes();

  const isCountryNameValue = field.value && field.value.length > 2; // on deprecation path

  return (
    <CountrySelector
      constrainInputWidth={constrainInputWidth}
      error={meta.touched && meta.error ? meta.error : undefined}
      fullWidth={fullWidth}
      isOptional={isRequired === false}
      label={label}
      onChange={(value) =>
        helpers.setValue(isAlpha2Enabled ? value.value : value.label)
      }
      placeholder={m.address_selectCountryPlaceholder()}
      tooltipContent={tooltipContent}
      value={
        isCountryNameValue ? getCountryCodeByName(field.value) : field.value
      }
    />
  );
}
